import Home from "./Home";
import OneWrapper from "./one";
import OneCollects from "./one/collects";
import OneInformation from "./one/information";

export const SupervisorUsersHome = Home;
export const SupervisorUsersOneWrapper = OneWrapper;
export const SupervisorUsersOneCollects = OneCollects;
export const SupervisorUsersOneInformation = OneInformation;